import { constants } from "constants/constants";
import { useRouter } from "next/router";
import React from "react";
import { SubscriptionType } from "services/api/sessions/sessionService.types";
import { LockIcon } from "../assets/lock-icon";
import { QnAIcon } from "../assets/qna-icon";
import { ClassSessionType } from "../hooks/use-user-landing/use-user-landing.types";
import { TrialActivationModal } from "../trial-activation-modal/trial-activation-modal";
import { useTrialActivationModal } from "../trial-activation-modal/use-trial-activation";
import {
  BlobRed,
  JoinClassWrapper,
  StyledButton,
  StyledTooltipButton,
  Tooltip
} from "./join-class.styles";
import {
  IJoinClassProps,
  IQnAInteractionFeatureValue
} from "./join-class.types";
import { useFeatureValue } from "@growthbook/growthbook-react";
import { GrowthbookFeatures } from "../../growthbook/growthbook.types";
import trackEvent from "../../../services/mixpanel/mixpanel";
import { kelasLiveEvents } from "../../../services/mixpanel/kelas-live-events";

const JoinClass: React.FC<IJoinClassProps> = ({
  classSession,
  classType,
  handleJoinClass,
  subscriptionStatus,
  primaryUser,
  handleJoinQnA,
  disabled,
  onShowPausedSubscriptionModal
}) => {
  const subscriptionType = subscriptionStatus.subscriptionType;
  const { showTrialActivation, setShowTrialActivation } =
    useTrialActivationModal(primaryUser.access_token);
  const router = useRouter();
  const handleTooltipClick = () => {
    if (subscriptionType === SubscriptionType.FREE) {
      handleJoinClass(classSession);
    } else {
      router.push({ pathname: constants.redirect_to.paket });
    }
  };

  const featureValue = useFeatureValue(GrowthbookFeatures.qnaInteraction, null);

  return (
    <>
      <JoinClassWrapper>
        {(featureValue as IQnAInteractionFeatureValue | null)?.showQnA ? (
          <StyledButton
            variant="secondary"
            onClick={(e: React.SyntheticEvent) => {
              e.stopPropagation();

              if (subscriptionType === SubscriptionType.PAUSED) {
                onShowPausedSubscriptionModal?.();
              } else {
                if (handleJoinQnA) {
                  trackEvent({
                    eventName: kelasLiveEvents.qnaIconClicked,
                    payload: {
                      iconClickSource: "webLink",
                      actionTaken: "openQ&A",
                      iconState: "default"
                    }
                  });
                  handleJoinQnA(classSession);
                }
              }
            }}
            disabled={
              disabled ||
              classType === ClassSessionType.UPCOMING ||
              subscriptionType === SubscriptionType.FREE_AFTER_TRIAL ||
              subscriptionType === SubscriptionType.FREE_AFTER_PAID
            }
          >
            {(disabled ||
              subscriptionType === SubscriptionType.FREE_AFTER_TRIAL ||
              subscriptionType === SubscriptionType.FREE_AFTER_PAID) && (
              <LockIcon />
            )}
            <QnAIcon /> &nbsp; Q&A
          </StyledButton>
        ) : null}
        <StyledButton
          variant="primary"
          onClick={(e: React.SyntheticEvent) => {
            e.stopPropagation();

            if (subscriptionType === SubscriptionType.PAUSED) {
              onShowPausedSubscriptionModal?.();
            } else {
              handleJoinClass(classSession);
            }
          }}
          disabled={
            disabled ||
            classType === ClassSessionType.UPCOMING ||
            subscriptionType === SubscriptionType.FREE_AFTER_TRIAL ||
            subscriptionType === SubscriptionType.FREE_AFTER_PAID
          }
        >
          {(disabled ||
            subscriptionType === SubscriptionType.FREE_AFTER_TRIAL ||
            subscriptionType === SubscriptionType.FREE_AFTER_PAID) && (
            <LockIcon />
          )}
          Masuk sekarang {classType === ClassSessionType.ONGOING && <BlobRed />}
        </StyledButton>

        {subscriptionType !== SubscriptionType.TRIAL &&
          subscriptionType !== SubscriptionType.PAID &&
          subscriptionType !== SubscriptionType.PAUSED && (
            <Tooltip>
              {subscriptionType === SubscriptionType.FREE
                ? "Kamu bisa coba kelasnya GRATIS! ✨"
                : "Langganan paket biar bisa masuk kelas ✨"}
              {((classType === ClassSessionType.UPCOMING &&
                subscriptionType === SubscriptionType.FREE) ||
                (subscriptionType !== SubscriptionType.FREE &&
                  "Cek paket belajar")) && (
                <StyledTooltipButton
                  variant="primary"
                  isFullWidth
                  onClick={handleTooltipClick}
                >
                  {classType === ClassSessionType.UPCOMING &&
                    subscriptionType === SubscriptionType.FREE &&
                    "Coba gratis dulu"}
                  {subscriptionType !== SubscriptionType.FREE &&
                    "Cek paket belajar"}
                </StyledTooltipButton>
              )}
            </Tooltip>
          )}
      </JoinClassWrapper>
      {showTrialActivation && (
        <TrialActivationModal
          primaryUser={primaryUser}
          onClose={() => setShowTrialActivation.off()}
          subscriptionStatus={subscriptionStatus}
        />
      )}
    </>
  );
};

export { JoinClass };
